import { CodecUtils } from 'common/utils/codec-utils';

export enum KreoProduct {
  View = 'View',
  BillOfQuantities = 'BillOfQuantities',
  Qto2D = 'Qto2D',
  Database = 'Database',
  Plan = 'Plan',
  CostEstimate = 'CostEstimate',
  Takeoff2dAutoMeasure = 'Takeoff2dAutoMeasure',
  Takeoff2dAutoMeasureApi = 'Takeoff2dAutoMeasureApi',
  Takeoff2dAnnotations = 'Takeoff2dAnnotations',
  Project2DTemplates = 'Project2DTemplates',
  PropertiesItemsAssemblies = 'PropertiesItemsAssemblies',
  Modular = 'Modular',
  RevitExport = 'RevitExport',
}

export const basicKreoProducts = [ KreoProduct.View ];

export const KreoProductC = CodecUtils.createEnumCodec<KreoProduct>(KreoProduct, 'KreoProduct');
